module.exports = __webpack_public_path__ + "img/report.5d4191c2.svg";